import { LayoutNavigationExtra, LayoutRoute } from 'src/app/_core/services/layout.service';

const stateName = '[Shared][NavigationManager] ';

export class SharedNavigationManagerSetRouteAction {
    static readonly type = stateName + 'SharedNavigationManagerSetRoute';
    constructor(public route: [LayoutRoute, LayoutNavigationExtra]) {
    }
}

export class SharedNavigationManagerRemoveLastRouteAction {
    static readonly type = stateName + 'SharedNavigationManagerRemoveLastRoute';
}

export class SharedNavigationManagerResetAction {
    static readonly type = stateName + 'SharedNavigationManagerReset';
}

